export default __webpack_public_path__ + "69da532b861527ccd4c3a42497ad9605.svg";